import React, { Component } from 'react'
import { Glyphicon } from 'react-bootstrap'
import { TimelineEvent } from 'react-event-timeline'
import { object } from 'prop-types'
import moment from 'moment'

import WorkflowStepLink from './WorkflowStepLink'
import WorkflowStepUpload from './WorkflowStepUpload'
import WorkflowStepCheck from './WorkflowStepCheck'

class WorkflowStep extends Component {
  render () {
    const { step } = this.props
    let configStatus = 'incomplete'
    let component = <div />
    if (step.completed) {
      configStatus = 'complete'
    }
    const config = {
      complete: {
        iconColor: '#6fba18',
        cardColor: '#6fba18',
        cardTextColor: '#fff',
        glyph: 'ok'
      },
      incomplete: {
        iconColor: '#7bb1ea',
        cardColor: '#7bb1ea',
        cardTextColor: '#fff',
        glyph: 'list-alt'
      }
    }
    switch (step.type) {
      case 'upload':
        component = <WorkflowStepUpload {...this.props} />
        break
      case 'link':
        component = <WorkflowStepLink {...this.props} />
        break
      case 'check':
        component = <WorkflowStepCheck {...this.props} />
        break
      default:
        component = <WorkflowStepCheck {...this.props} />
    }
    let time = moment(step.completed_at).format('LLL')
    return (
      <TimelineEvent
        createdAt={step.completed ? `${time} por ${step.completed_by_name}` : ''}
        title={<h4 className='no-margin'>{step.name}</h4>}
        icon={
          <Glyphicon
            glyph={config[configStatus].glyph}
            style={{ color: config[configStatus].iconColor }}
          />
        }
        iconColor={config[configStatus].iconColor}
        container='card'
        cardHeaderStyle={{
          backgroundColor: config[configStatus].cardColor,
          color: config[configStatus].cardTextColor
        }}
      >
        {component}
      </TimelineEvent>
    )
  }
}

WorkflowStep.propTypes = {
  step: object
}

export default WorkflowStep



// WEBPACK FOOTER //
// ./src/components/WorkflowStep.js